import React from 'react';
import { useNavigate } from 'react-router-dom'; // 1. Yönlendirme için hook'u import et
import './HeroSection.css';
import DoctorName from '../DoctorName/DoctorName';

const HeroSection = () => {
  const navigate = useNavigate(); // 2. Navigate fonksiyonunu tanımla

  return (
    <section className="hero-full">
      {/* Arka Plan Görseli ve Karartma Katmanı */}
      <div className="hero-bg-wrapper">
        <div className="hero-overlay"></div>
        <img 
          src="https://images.unsplash.com/photo-1516627145497-ae6968895b74?q=80&w=2000&auto=format&fit=crop" 
          alt="Çocuk Sağlığı ve Cerrahisi" 
          className="hero-bg-img"
        />
      </div>

      <div className="hero-full-content">
        <div className="content-inner">
         <span className="hero-top-text">GELECEĞİMİZ ONLARA EMANET</span>
<h1 className="hero-main-title">
  Çocuk Cerrahisinde <br />
  <span>Uzmanlık ve Özen</span>
</h1>
<p className="hero-sub-description">
  <DoctorName /> ile minik kalplerin sağlığı için en modern cerrahi
  yaklaşımlar ve aile sıcaklığında bir tedavi süreci.
</p>
          
          <div className="hero-full-btns">
            {/* 3. onClick olaylarını rotalarına mühürle */}
            <button 
              className="btn-main" 
              onClick={() => navigate('/randevu-al')}
            >
              RANDEVU OLUŞTUR
            </button>
            
            <button 
              className="btn-outline" 
              onClick={() => navigate('/uzmanliklar')}
            >
              UZMANLIK ALANLARI
            </button>
          </div>
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;